import "core-js/modules/es.array.splice";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  meta: {
    title: '回复模板',
    auth: true,
    authorityValue: "store-evaluate-manage"
  },
  name: 'commentModel',
  data: function data() {
    return {
      layer: {
        show: false,
        title: '添加回复模板',
        width: '400px',
        showButton: true,
        form: {}
      },
      tableData: [],
      total: 0
    };
  },
  methods: {
    confirm: function confirm() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.saveReplyTemplate(_this.layer.form);

              case 2:
                _this.layer.show = false;

                _this.$notify.success({
                  title: '成功',
                  message: '保存成功'
                });

                _this.dataBind();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clickLayer: function clickLayer(e) {
      for (var key in this.layer.form) {
        this.layer.form[key] = '';
      }

      this.layer.form = _objectSpread(_objectSpread({}, e), {}, {
        templateId: e.templateId ? e.templateId : ''
      });
      this.layer.show = true;
    },
    clickDel: function clickDel(e, index) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.deleteReplyTemplate({
                  templateId: e.templateId
                });

              case 2:
                _this2.tableData.splice(index, 1);

                _this2.$notify.success({
                  title: '成功',
                  message: '删除成功'
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    pagination: function pagination(e) {
      this.dataBind(e);
    },
    dataBind: function dataBind(item) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$_this3$$api$re, total, records;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$api.replyTemplates(item);

              case 2:
                _yield$_this3$$api$re = _context3.sent;
                total = _yield$_this3$$api$re.total;
                records = _yield$_this3$$api$re.records;
                _this3.tableData = records;
                _this3.total = total;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  created: function created() {
    this.dataBind();
  }
};